'use client';
import { useNewsletterTag } from '@hooks/use-newsletter-tag';
import { FollowList, LoggedInUserProps } from '@interfaces/auth';
import { useSession } from 'next-auth/react';
import { useEffect, useState } from 'react';
import { TeamListItem } from './TeamListItem';
import type { PopularTeam } from './types';

interface Props {
  items: PopularTeam[];
  favorites?: FollowList;
  userToken?: string;
}

export const PopularTeamsList = ({ items, favorites, userToken }: Props) => {
  const { update, data } = useSession();
  const sessionUser = data?.user as LoggedInUserProps | undefined;
  const sessionFavorites = sessionUser?.follow ?? favorites;
  const sessionToken = sessionUser?.token?.accessToken ?? userToken;
  const [favoritiesList, setFavoritiesList] = useState(sessionFavorites);

  const { addTagToUser, removeTagFromuser } = useNewsletterTag();

  useEffect(() => {
    setFavoritiesList(sessionFavorites);
  }, [sessionFavorites]);

  const userEmail = sessionUser?.email;

  const onFavoriteUpdate = async (item: FollowList[number]) => {
    await addTagToUser({ email: userEmail!, tag: item.name });
    await update({
      follow: [
        ...(favoritiesList || []),
        { id: item.id, type: 'p', name: item.name },
      ],
    });
    setFavoritiesList((oldValue) => {
      return [
        ...(oldValue || []),
        { id: item.id, type: 'performer', name: item.name },
      ];
    });
  };

  const onRemoveFavoriteUpdate = async (item: FollowList[number]) => {
    const removedFollowList = favoritiesList?.filter(
      (fav) => fav.id !== item.id
    );

    await removeTagFromuser({ email: userEmail!, tag: item.name });

    await update({
      follow: removedFollowList,
    });

    setFavoritiesList(removedFollowList);
  };

  return (
    <>
      {items.map((performer) => {
        const isFavorite = favoritiesList?.find(
          (item) => item.id === performer.id
        );
        return (
          <TeamListItem
            key={`${performer.category.slug}/${performer.slug}`}
            isFavorite={isFavorite}
            performer={performer}
            onFavoriteUpdate={onFavoriteUpdate}
            onRemoveFavoriteUpdate={onRemoveFavoriteUpdate}
            userToken={sessionToken}
          />
        );
      })}
    </>
  );
};
